'use strict';
define([
    'angular',
    'modules/googleads/googleads.routes',
    'modules/googleads/planner/planner.module'
], function (angular, routes) {
    var app = angular.module('app.googleads', [
        'app.googleads.planner',
    ]);
    app.config(routes);
    return app;
});
